import Performer from '@/components/layout-components/widgets/history/Performer'
import CommentsForm from '@/components/layout-components/widgets/history/CommentsForm'
export default {
  components: {
    Performer,
    CommentsForm,
  },
  methods: {
    formatDate (date) {
      const dateObj = new Date(date)
      if (this.isToday(dateObj)) {
        return `${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`
      }
      return dateObj.toLocaleString()
    },
    isToday (date) {
      const today = new Date()
      return date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    },
  },
}
